module.exports = __webpack_public_path__ + "static/img/espacios-naturales-protegidos.724c5952.png";